// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.waiting-room__message {
  text-align: center;
  font-size: 20px;
  padding-top: 10vh;
  padding-bottom: 10vh;
  max-width: 60%;
  margin: 0 auto;
}
.waiting-room__footer {
  padding-bottom: 30px;
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/WaitingRoom/WaitingRoom.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,cAAA;AAAR;AAGI;EACI,oBAAA;EACA,eAAA;AADR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
